/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // ------------------------------------------
  // 1. Core Logic Function (To be run multiple times)
  // ------------------------------------------
  function initializeCustomFilters() { 
      // A. Copy list and remove hidden
      var categoryHtml = $('.filter-group--category .filter-group__content ul.collection-nav').html();
      $('.category__filter .category__filter-nav').html(categoryHtml); // Use .html() to clear and set
      $('.category__filter .category__filter-nav li').removeClass('hidden');

      // B. Initial Synchronization: Check the hidden inputs and set the custom UI state
      $('.filter-group--category .filter-group__content ul.collection-nav li input[type="checkbox"]').each(function() {
          var originalId = $(this).attr('id');
          // Synchronize the custom UI state with the hidden input's checked state
          var isChecked = $(this).is(':checked');
          $('.category__filter .category__filter-nav li input#' + originalId).prop('checked', isChecked);
      });
      
  }
    
  // Synchronize on Custom Filter Clicks
  $('body').off('click', '.category__filter .category__filter-nav li input').on('click', '.category__filter .category__filter-nav li input', function() {
      var id = $(this).attr('id');

      // Trigger the click on the ORIGINAL hidden input
      $('.filter-group--category .filter-group__content ul.collection-nav li input#' + id).trigger('click');
        
      (initializeCustomFilters); 
  });

  // Listen for clicks on the 'X' button next to an active filter tag.
  $('body').off('click', '.active__filters__remove').on('click', '.active__filters__remove', function(e) {
      var filterText = $(this).find('small').text().trim(); 

      $('.filter-group--category .filter-group__content ul.collection-nav li input[type="checkbox"]').each(function() {
          
          var $input = $(this);
          var $listItem = $input.closest('li');
          var $label = $listItem.find('label'); 
          var $span = $label.find('span'); 
          console.log("spna", $span.text());

          if ( $span.text().trim().includes(filterText)) {            
          var originalId = $(this).attr('id');
            // Synchronize the custom UI state with the hidden input's checked state
            var isChecked = $(this).is(':checked');
            if ( $(this).is(':checked')) {

                $('.category__filter .category__filter-nav li input#' + originalId).prop('checked', false);
                return false;
            }
          }
      }); 
  });

  // Clear Filters Logic (Delegation)
  $('body').off('click', '.active__filters__clear').on('click', '.active__filters__clear', function(e) { 
      // This instantly fixes the visual bug.
      $('.category__filter .category__filter-nav li input[type="checkbox"]').prop('checked', false);
      
      // After the theme's logic runs (which is usually fast), force a UI reset

      (function() {
        $('.filter-group--category .filter-group__content ul.collection-nav li input[type="checkbox"]').each(function() {
          var originalId = $(this).attr('id'); 
          var $this = $(this);
          $this.prop('checked', false); 

      }); 
          initializeCustomFilters();
      }, );  
  }); 
  // A. Run on initial page load
  initializeCustomFilters();

  // Try to find the event your theme fires (common ones listed below)
  $(document).on('shopify:section:load theme:filters:changed theme:section:load', function() {
      initializeCustomFilters();
  });


  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
